export const FMLX_COMPONENT = {
  SIZE: {
    XS: 'xs',
    S: 'sm',
    M: 'md',
    L: 'lg',
    XL: 'xl',
  },
  PLACEMENT: {
    START: 'start',
    END: 'end',
    TOP: 'top',
    BOTTOM: 'bottom',
  },
  ALIGNMENT: {
    LEFT: 'left',
    CENTER: 'center',
    RIGHT: 'right',
  },
  DIRECTION: {
    ROW: 'row',
    COLUMN: 'column',
  },
};

export const FMLX_BUTTON = {
  TYPE: {
    PRIMARY: 'primary',
    POSITIVE: 'positive',
    DANGER: 'danger',
    BASIC: 'basic',
  },
  VARIANT: {
    CONTAIN: 'contain',
    OUTLINE: 'outline',
    PLAIN: 'plain',
    ACTION_BUTTON: 'action-button',
  },
  WITH_ICON: {
    DISABLE: 'disable',
    START: 'start',
    END: 'end',
  },
  PLACEMENT: {
    TOP: 'top',
    RIGHT: 'right',
    LEFT: 'left',
    BOTTOM: 'bottom',
  },
  MODE: {
    BUTTON: 'button',
    SWITCH: 'switch',
  },
  PROGRESS_POSSITION: {
    RIGHT: 'right',
    LEFT: 'left',
  },
};
export const FMLX_BUTTON_GROUP = {
  TYPE: {
    OUTLINE: 'outline',
    CONTAIN: 'contain',
  },
  VARIANT: {
    ICON: 'icon',
    TEXT: 'text',
    BOTH: 'both',
  },
};
export const FMLX_CHECK_BOX = {
  SIZE: {
    S: 'sm',
    M: 'md',
    L: 'lg',
  },
  LABEL_PLACEMENT: {
    LEFT: 'left',
    RIGHT: 'right',
    TOP: 'top',
    BOTTOM: 'bottom',
  },
};
export const FMLX_CHIP = {
  VARIANT: {
    OUTLINED: 'outlined',
    FILLED: 'filled',
  },
  TYPE: {
    DEFAULT: 'default',
    SAFE: 'safe',
    DANGER: 'danger',
    WARNING: 'warning',
  },
};
export const FMLX_POPOVER = {
  Horizontal: {
    LEFT: 'left',
    CENTER: 'center',
    RIGHT: 'right',
  },
  Vertical: {
    TOP: 'top',
    CENTER: 'center',
    BOTTOM: 'bottom',
  },
  AnchorReference: {
    anchorEl: 'anchorEl',
    anchorPosition: 'anchorPosition',
    none: 'none',
  },
};
export const FMLX_PROGRESS_BAR = {
  TYPE: {
    CIRCULAR: 'circular',
    LINEAR: 'linear',
  },
  SIZE: {
    SMALL: 'sm',
    MEDIUM: 'md',
  },
  VARIANT: {
    INDETERMINATE: 'indeterminate',
    DETERMINATE: 'determinate',
  },
};
export const FMLX_RADIO_BUTTON = {
  SISE: {
    SMALL: 'sm',
    MEDIUM: 'md',
    LARGE: 'lg',
    EXTRA_LARGE: 'xl',
  },
  HINT_TYPE: {
    INFORMATION: 'information',
    WARNING: 'warning',
    ERROR: 'error',
  },
  PLACEMENT: {
    START: 'start',
    END: 'end',
    TOP: 'top',
    BOTTOM: 'bottom',
  },
};
export const FMLX_SWITCH = {
  SIZE: {
    XS: 'xs',
    S: 'sm',
    M: 'md',
    L: 'lg',
  },
  PLACEMENT: {
    START: 'start',
    TOP: 'top',
  },
};
export const FMLX_TABLE = {
  TYPE: {
    BASIC: 'basic',
    MULTISELECT: 'multiselect',
    COLLAPSIBLE: 'collapsible',
  },
  SORT_TYPE: {
    ASC: 'asc',
    DESC: 'desc',
  },
  FILTER_TYPE: {
    TEXT: 'text',
    DROPDOWN: 'dropdown',
    DATEPICKER: 'datepicker',
    CUSTOM: 'custom',
  },
};
export const FMLX_TEXT_INPUT_BOX = {
  SIZE: {
    SMALL: 'sm',
    MEDIUM: 'md',
    LARGE: 'lg',
    EXTRA_LARGE: 'xl',
  },
  VARIANT: {
    STANDARD: 'standard',
    OUTLINE: 'outline',
  },
  MODE: {
    TEXT: 'text',
    NUMBER: 'number',
    EMAIL: 'email',
    TEXTAREA: 'textarea',
    PASSWORD: 'password',
  },
  DECORATION: {
    NONE: 'none',
    ICON: 'icon',
    COUNTER: 'counter',
    UNIT: 'unit',
  },
};
export const FMLX_WIZARD = {
  TYPE: {
    MODAL: 'modal',
    PAGE: 'page',
  },
};
export const FMLX_TOOLTIP = {
  PLACEMENT: {
    BOTTOM_END: 'bottom-end',
    BOTTOM_START: 'bottom-start',
    BOTTOM: 'bottom',
    LEFT_END: 'left-end',
    LEFT_START: 'left-start',
    LEFT: 'left',
    RIGHT_END: 'right-end',
    RIGHT_START: 'right-start',
    RIGHT: 'right',
    TOP_END: 'top-end',
    TOP_START: 'top-start',
    TOP: 'top',
  },
};
export const FMLX_MODAL = {
  SIZE: {
    SM: 'sm',
    MD: 'md',
    LG: 'lg',
    XL: 'xl',
  },
};
export const FMLX_BANNER = {
  Variant: {
    INFO: 'info',
    WARNING: 'warning',
    ERROR: 'error',
  },
};
